module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/facebook.8625e2a7.svg";